import React, { useEffect, useState } from 'react'
import { HiDotsVertical, HiOutlinePencil } from 'react-icons/hi'
import FloatingMenu from '../../components/Display/FloatingMenu'
import { MdOutlineCategory, MdOutlineDescription } from 'react-icons/md'
import { ICategory } from 'safe'
import ModalConfirm from '../../components/Display/ModalConfirm'
import { returnCategoryString } from '../../utils/utils'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import Modal from '../../components/Display/Modal'
import Button from '../../components/General/Button'
import { AiFillRead } from 'react-icons/ai'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'

const CategoryCard: React.FC<LocationCardProps> = ({
  category,
  setModal,
  setEditingCategory,
  onDelete,
  setModalSubCategory,
  setSelectedCategory,
  setAddNew
}) => {
  const [visibleMenu, setVisibleMenu] = useState<boolean>(false)
  const [modalDescription, setModalDescription] = useState<boolean>(false)
  const [displayConfirm, setDisplayConfirm] = useState<boolean>(false)
  const [selectedTab, setSelectedTab] = useState<number>(0)

  const [subCategories, setSubCategories] = useState<any[]>([])

  const [showModalItemsSub, setShowModalItemsSub] = useState<boolean>(
    false
  )

  const [categories, setCategories] = useState<any[]>([])

  const [itemsBySubcategories, setItemsBySubcategories] = useState<any[]>([])

  const server = process.env.REACT_APP_SERVER_URL

  const userRole = useSelector(
    (state: RootState) => state.auth.user['custom:user_role']
  )

  const getItemsBySubcategory = async () => {
    let response = await axios.get(
      `${server}/inventory/item?evaluate=category&idCategory=${category.id}`
    )
    setItemsBySubcategories(response.data.items)
  }

  useEffect(() => {
    // getCategories()

    getItemsBySubcategory()

  }, [])

  const tabs = ['Artículos por categoría', 'Artículos por Subcategoría']

  const toggle = (): void => {
    setVisibleMenu((state) => !state)
  }

  const edit = (): void => {
    toggle()
    setModal(true)
    setEditingCategory(category)
  }

  const _delete = (): void => {
    onDelete(category)
    toggle()
  }

  const subCategory = (): void => {
    setSelectedCategory(category)
    setModalSubCategory(true)
  }

  const renderItemDetail = (items) => {
    return (
    <div className="max-h-56 overflow-y-scroll">
          {items.map((subCategory) => (
            <div
              className="bg-gray-100 dark:bg-gray-800 rounded-lg mt-6 p-3.5 flex justify-between items-center"
              key={subCategory.id}
            >
              <div className='flex flex-col'>
                 <h3>Nombre: {subCategory.name}</h3>
                 <h3>Código: { subCategory.barcode || subCategory.sku }</h3>
                 <h3>Descripción {subCategory.description}</h3>
              </div>
            </div>
          ))}
        </div>
    )
  }

  return (
    <>
      {/* <ModalViewWithTabs
        display={modalDescription}
        onClose={() => {
          setModalDescription(false)
        }}
        dataWithTabs={[
          { title: 'Categoría', data: returnCategoryString(category) },
          {title: 'Artítulos por categoria', data: 'Hola'}
        ]}
      /> */}
      <Modal
        display={modalDescription}
        onClose={() => setModalDescription(false)}
      >
        <>
          <div className="flex flex-nowrap rounded-lg bg-gray-100 divide-x-2 divide-gray-200 dark:bg-gray-800 m-auto mb-10">
            {tabs.map((tab, i) => (
              <div
                key={tab}
                className={`px-3 flex-grow transition-all py-2.5 flex items-center justify-center ${
                  selectedTab === i
                    ? 'bg-white dark:bg-gray-600'
                    : 'dark:bg-gray-900'
                }`}
                onClick={async () => {
                  /** Traer articulos por categoria */
                  if (i === 0) {
                    await getItemsBySubcategory()
                    setSelectedTab(i)

                  /** Traer articulos por subcategoria 
                   * listando primero las subcategorias.
                  */
                  } else {
                    let response = await axios.get(`${server}/inventory/subcategory?evaluate=SUB_CATEGORY_ALL_EVALUATE?idCategory=${category.id}`)
                    setSelectedTab(i)
                    setSubCategories(response.data.subcategories)
                  }
                }}
              >
                <div className={`h-full flex items-center`}>
                  <span className="text-center">
                    {/* <Icon
              className={`${
                i === selected
                ? 'text-primary dark:text-white'
                : 'text-trueGray-600 dark:text-gray-300'
              } mr-3 z-20 text-lg`}
            /> */}
                  </span>
                  <p
                    className={`${
                      selectedTab === i
                        ? 'text-primary dark:text-white'
                        : 'text-trueGray-600 dark:text-gray-300'
                    }`}
                  >
                    <b>{tab}</b>
                  </p>
                </div>
              </div>
            ))}
          </div>

          {selectedTab === 0 && (
            renderItemDetail(itemsBySubcategories)
          )}

          {selectedTab === 1 && (
            <div className="max-h-56 overflow-y-scroll">
              {subCategories.map((subCategory) => (
                <div
                  className="bg-gray-100 dark:bg-gray-800 rounded-lg mt-6 p-3.5 flex justify-between items-center"
                  key={subCategory.id}
                >
                  <div className="flex justify-between items-center w-full">
                    <h2>{subCategory.name}</h2>
                    <Button
                      classes="mt-4 border-none"
                      onClick={async () => {
                        let response = await axios.get(
                          `${server}/inventory/item?evaluate=ITEM_ALL_EVALUATE&subcategory=${subCategory.id}`
                        )
                        setShowModalItemsSub(true)
                        setItemsBySubcategories(response.data.items)
                      }}
                    >
                      <AiFillRead size={20} className="text-primary-700" />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      </Modal>

      <Modal
        display={showModalItemsSub}
        onClose={() => setShowModalItemsSub(false)}
      >
        {renderItemDetail(itemsBySubcategories)}
      </Modal>

      <div className="2xl:w-96 w-80 shadow-lg rounded-lg p-4 text-xl flex justify-between relative dark:bg-black m-auto">
        <div
          className="w-72 cursor-pointer"
          // onClick={() => setModalDescription(true)}
          // style={{ opacity: category.children.length === 0 ? '0.6' : '1' }}
          style={{opacity: '1'}}
        >
          <div className="flex mb-3">
            <div className="mr-4 text-primary-600">
              <MdOutlineCategory size="1.2rem" className="text-primary" />
              {/* {iconType === 'warehouse' && <GiHammerSickle size="1.2rem" />} */}
            </div>
            <div className="truncate text-primary-600 font-medium text-sm dark:text-white">
              {category.name}
            </div>
          </div>
          <div className="h-8 flex items-center">
            <div className="flex items-center truncate text-primary-600 font-medium">
              <div className="mr-4">
                <MdOutlineDescription size="0.9rem" className="text-primary" />
              </div>
              <div className="truncate text-sm max-h-10 dark:text-white">
                {category.description}
              </div>
            </div>
          </div>

          <div className="h-8 flex justify-between">
            <div className="flex items-center truncate text-primary-600 font-medium">
              <div
                className={`truncate text-sm max-h-10 ${
                  // category.children.length === 0
                  //   ? 'text-danger'
                  //   : 'text-primaryGreen-dark dark:text-primaryGreen'
                  'text-primaryGreen-dark dark:text-primaryGreen'
                }`}
                style={{ fontSize: '12px' }}
              >
                {/* {category.children.length}{' '} */}
                {/* {'subcategorias'.slice(
                  0,
                  category.children.length === 1 ? 12 : 13
                )} */}
                {/* {'subcategorias'} */}
              </div>
            </div>

            <div className="flex items-center truncate text-primary-600 font-medium">
              <div
                className="truncate text-sm max-h-10 dark:text-white"
                style={{ fontSize: '12px' }}
              >
                {category.code}
              </div>
            </div>
          </div>
        </div>

        <FloatingMenu
          onClose={() => setVisibleMenu(false)}
          visible={visibleMenu}
          options={{
            // onAddSubCategory: () => {
            //   setAddNew && setAddNew(true)
            //   setEditingCategory(category)
            // },
            onEdit: edit,
            onDelete: () => _delete(),
            // onSubCategory: subCategory,
          }}
        >
          {userRole !== 'seniat' && (
          <HiDotsVertical
            className="cursor-pointer text-gray-400"
              onClick={toggle}
            />
          )}
        </FloatingMenu>
      </div>

      {/* <ModalConfirm
        title={'¿Está seguro que desea eliminar la categoria?'}
        displayConfirmModal={displayConfirm}
        onConfirm={() => _delete()}
        onCancel={() => setDisplayConfirm(false)}
      ></ModalConfirm> */}
    </>
  )
}

export default CategoryCard

interface LocationCardProps {
  category: ICategory
  setModal: (value: boolean) => void
  setEditingCategory: (category: ICategory) => void
  iconType: string
  onDelete: (category: ICategory) => void
  setModalSubCategory: (value: boolean) => void
  setSelectedCategory: (category: ICategory) => void
  setAddNew?: Function
}
